import { useEffect, useState } from "react";
import { QUERIES } from "../../../config/apiConfig";
import axiosInstance from "../../../config/axiosInstance";
import { Spinner } from "flowbite-react";

const PdfViewer = ({ url, message = "" }) => {
  const [imagem, setImagem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    const carregarImagem = async () => {
      if (!url) return;

      setLoading(true);
      setErro(false);

      try {
        const response = await axiosInstance.get(
          `${QUERIES.GET_IMG_CSV}?url=${url}`,
          {
            responseType: "blob", // backend retorna imagem
          }
        );

        const imageUrl = URL.createObjectURL(response.data);
        setImagem(imageUrl);
      } catch (error) {
        console.error("Erro ao carregar imagem do PDF:", error);
        setErro(true);
      }

      setLoading(false);
    };

    carregarImagem();
  }, [url]);

  return (
    <div>
      {loading && (
        <div className="flex items-center justify-center gap-2 flex-col">
          <Spinner color="success" />
          {message === "" ? (
            <p className="text-center">Carregando visualização dos laudos...</p>
          ) : (
            <p className="text-center">{message}</p>
          )}
        </div>
      )}

      {erro && !loading && (
        <p style={{ color: "red" }} className="font-semibold text-center">
          Erro ao carregar a imagem do PDF.
        </p>
      )}

      {!loading && imagem && (
        <img
          src={imagem}
          alt="PDF convertido em imagem"
          style={{ width: "100%", marginBottom: "1rem", maxWidth: "800px" }}
          className="mx-auto border border-gray-100 shadow-sm mb-4"
        />
      )}

      {!loading && !imagem && !erro && <p>Nenhuma imagem encontrada.</p>}
    </div>
  );
};

export default PdfViewer;
